define('controllers/mysetting/namechange/name-change.ctrl',['app'], function (app) {
    app.controller('NameChangeCtrl', ['$q','$rootScope', '$state','$scope','UserInfoPreload','modBussService',
        function ($q, $rootScope,$state,$scope,UserInfoPreload,modBussService) {
            var Model = $scope.Model = {
                //对应[用户信息进行中，用户信息完成，银行信息未开始，银行信息进行中，银行信息完成，税务信息未开始，税务信息进行中，税务信息完成，完成未开始，完成已完成]
                statusArray:[1,0,1,0,0,1,0,0,1,0],
                userInfo:UserInfoPreload
            };

            //监控路由变化的
            $scope.$on('transfer.nameChange', function(event, data) {
                gotoState(data);
            });

            !function () {
                gotoState($state.current.name);
            }();

            function gotoState(data) {
                modBussService.getMerchantInfo(function(bankInfos){
                    Model.bankInfoCN = bankInfos.bankInfoCN;
                    if(UserInfoPreload.verifyBankState == 2){
                        Model.columnLengthStyle ={'width':(100/3)+'%'};
                        Model.columnLength =3;
                    }else{
                        Model.columnLengthStyle ={'width':'50%'};
                        Model.columnLength =2;
                    }
                    if(data == 'nameChangeCorp.userInfoCorp' || data == 'nameChangePer.userInfoPer'){
                        Model.greenLengthStyle={'width':(100/(Model.columnLength*2))+'%'};
                        Model.statusArray =[1,0,1,0,0,1,0,0,1,0]
                    }
                    if(data == 'nameChangeCorp.modBussnessInfo' || data == 'nameChangePer.modBussnessInfo'){
                        Model.greenLengthStyle={'width':(100/(Model.columnLength*2)+100/Model.columnLength)+'%'};
                        Model.statusArray =[0,1,0,1,0,1,0,0,1,0]
                    }
                    if(data == 'nameChangeCorp.submitSuccess' || data == 'nameChangePer.submitSuccess'){
                        Model.greenLengthStyle={'width':'100%'};
                        Model.statusArray =[0,1,0,0,1,0,0,1,0,1]
                    }
                });

            }

        }]);
});
